"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchData = void 0;
var promiseParams = '';

var fetchData = function fetchData(promise, currentParams) {
  if (!promise) return null;
  promiseParams = currentParams;
  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(function (result) {
      if (promiseParams === currentParams) {
        resolve(result);
      } else {
        reject(new Error('Promise was canceled'));
      }
    }, function (error) {
      if (promiseParams === currentParams) {
        reject(error);
      } else {
        reject(new Error('Promise was canceled'));
      }
    });
  });
  return wrappedPromise;
};

exports.fetchData = fetchData;